import { format } from 'date-fns';
var removeTimezone = function (date) {
    return format(date, 'yyyy-MM-dd');
};
export { removeTimezone };
